import React from 'react';

import { Ad } from '@memed/react-ad-manager';

import { useDispatch, useSelector } from 'react-redux';

import { AppState } from '@store/index';
import { setHasBanner } from '@store/banner/actions';
import { trackEvent } from '@monitoring/x-ray-tracker';

import { Container } from './BannerStyles';

interface onBannerRenderEndedParams {
  isEmpty: boolean;
}

type IBannerEvent = {
  advertiserId: number;
  campaignId: number;
  companyIds: number | null;
  creativeId: number;
  lineItemId: number;
  serviceName: string;
  size: googletag.GeneralSize;
  slot: string;
  isEmpty: boolean;
  sourceAgnosticCreativeId: number;
  sourceAgnosticLineItemId: number;
};

interface BannerProps {
  page: 'search';
}

const Banner = ({ page }: BannerProps): React.ReactNode => {
  const permissions = useSelector((state: AppState) => state.permissions);
  const hasBanner = useSelector((state: AppState) => state.banner.hasBanner);
  const dispatch = useDispatch();
  const currentDrugstoreData = React.useMemo(() => {
    const { current_drugstore } = permissions;

    if (!current_drugstore) {
      return {
        chain_id: '',
        chain_name: '',
        drugstore_id: '',
        drugstore_name: '',
        drugstore_uf: '',
        association: '',
      };
    }

    const { chain, id, complement, uf } = current_drugstore;

    return {
      chain_id: chain.id,
      chain_name: chain.name,
      drugstore_id: id,
      drugstore_name: complement,
      drugstore_uf: uf || '',
      association: chain.association || '',
    };
  }, [permissions]);

  const onBannerRenderEnded = (params: onBannerRenderEndedParams): void => {
    dispatch(setHasBanner(!params.isEmpty));

    const properties = {
      banner_properties: params,
      ...currentDrugstoreData,
    }

    if (!params.isEmpty) {
      trackEvent('Dispensation Banner View', page, properties);
    }
  };

  const handleClick = (params: IBannerEvent): void => {
    const properties = {
      banner_properties: params,
      ...currentDrugstoreData,
    }


    trackEvent('Dispensation Banner Click', page, properties);
  }

  if (permissions.loading || !currentDrugstoreData.chain_id) {
    return null;
  }

  return (
    <Container hasBanner={hasBanner}>
      <Ad
        id="banner-dispenser"
        adUnit="/22775373496/7"
        generalSize={[[970, 250], [1126, 250]]}
        targets={[
          ['chain', currentDrugstoreData.chain_id.toString()],
          ['uf', currentDrugstoreData.drugstore_uf],
          ['isAbrafarma', currentDrugstoreData.association === 'abrafarma' ? 'true' : 'false']
        ]}
        onRenderEnded={onBannerRenderEnded}
        onClick={handleClick}
        refreshTimer={10000}
        key={`banner-ad-key-${currentDrugstoreData.chain_id}`}
      />
    </Container>
  );
};

export default Banner;
